import BaseTabBar from './TabBar';

export { TabStripTab as Tab } from '@progress/kendo-react-layout';
export const TabBar = BaseTabBar;
export default BaseTabBar;
